import gql from 'graphql-tag';
import graphqlClient from '../helpers/graphqlClient';

export default new (class {
	async getAllCategories(facilityID) {
		const { data } = await graphqlClient.query({
			query: gql`
				query ResourcesOrdered(
					$where: String!
					$whereRecourceCategory: String!
				) {
					cmsResourceCategories(where: $whereRecourceCategory) {
						resourceCategory_ID
						name
						cmsResources(where: $where) {
							resource_ID
							name
							description
							fileType
							fileDataBase64
							link
							isActive
							facility_ID
						}
					}
				}
			`,
			variables: {
				where: `isActive=true && Facility_ID=${facilityID}`,
				whereRecourceCategory: `cmsResources.Count(it.facility_ID = ${facilityID}) > 0`
			},

			fetchPolicy: 'no-cache'
		});

		return data.cmsResourceCategories;
	}
})();
